import { Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function ShopIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Path d="M6 7h12l1 13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1L6 7Z" />
      <Path d="M9 10V6a3 3 0 0 1 6 0v4" />
    </LineIcon>
  );
}
